<script setup lang="ts"></script>

<template>
  <article
    class="group hover:shadow-glow flex flex-col gap-4 rounded-lg p-4 transition-all ease-in-out hover:scale-102 hover:bg-slate-50 md:flex-row md:items-center md:justify-between"
  >
    <slot />
  </article>
</template>
